module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAABhJREFUeNpiZGBgsGBAA0wMWACFggABBgAYjgBCU52H7gAAAABJRU5ErkJggg=="


/*****************
 ** WEBPACK FOOTER
 ** ./extjs/resources/themes/images/gray/shared/shadow-c.png
 ** module id = 476
 ** module chunks = 0
 **/